import React, { useEffect, useState } from 'react'

import { useMainContext } from '../../core/contexts/main'
import Dropdown from './DropDown'
import WebsiteIcon from '../icons/WebsiteIcon'

const languages = {
    en: 'english',
    fa: 'فارسی',
}

const languageOptions = ['english', 'فارسی']

const LangSwitcher = ({ position, offset }) => {
    const {
        main: { lang, setLang },
    } = useMainContext()

    const [open, setOpen] = useState(false)
    const [searchValue, setSearchValue] = useState('')

    const onSelect = (option) => {
        if (option === 'english') setLang('en')
        if (option === 'فارسی') setLang('fa')
        setOpen(false)
    }


    return (
        <Dropdown
            open={open}
            setOpen={setOpen}
            options={languageOptions.filter((o) =>
                o.toLowerCase().includes(searchValue.toLowerCase())
            )}
            renderOption={(option) => (
                <span className="capitalize">{option}</span>
            )}
            togglerContent={
                <span className="mr-2 capitalize flex items-center gap-1">
                    <WebsiteIcon size={20} />
                    {languages[lang]}
                </span>
            }
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            onSelect={onSelect}
            className="w-full"
            position={position}
            offset={offset}
        />
    )
}

export default LangSwitcher
